import React from "react";
import { Typography } from "antd";
import type { TypographyProps } from "antd";
import type { TitleProps } from "antd/es/typography/Title";
import type { ParagraphProps } from "antd/es/typography/Paragraph";
import type { TextProps } from "antd/es/typography/Text";
import { twMerge } from "tailwind-merge";

const { Title, Paragraph, Text } = Typography;

interface CustomTypographyWrapProps extends TypographyProps {
  children: React.ReactNode;
  className?: string;
}

interface CustomTitleProps extends TitleProps {
  children: React.ReactNode;
  className?: string;
}

interface CustomParagraphProps extends ParagraphProps {
  children: React.ReactNode;
  className?: string;
}

interface CustomTextProps extends TextProps {
  children: React.ReactNode;
  className?: string;
}

export const CustomTypographyWrap: React.FC<CustomTypographyWrapProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Typography className={twMerge("!text-black", className)} {...rest}>
      {children}
    </Typography>
  );
};

export const CustomTitle: React.FC<CustomTitleProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Title className={twMerge("!text-black", className)} {...rest}>
      {children}
    </Title>
  );
};

export const CustomParagraph: React.FC<CustomParagraphProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Paragraph className={twMerge("!text-black", className)} {...rest}>
      {children}
    </Paragraph>
  );
};

export const CustomText: React.FC<CustomTextProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Text className={twMerge("!text-black", className)} {...rest}>
      {children}
    </Text>
  );
};

const CustomTypography = {
  CustomTypographyWrap,
  CustomTitle,
  CustomParagraph,
  CustomText,
};

export default CustomTypography;
